<template>
  <div id="forecastRunnerStatus">
    <div class="dongle" v-bind:class="{ show: showDongle }" v-on:click="toggleLogView()">
      <svg version="1.1" viewBox="0 0 130 134" xmlns="http://www.w3.org/2000/svg">
        <g fill="#5C5B64">
          <path
              d="m97.4 0-32.789 18.903v7e-3l33.172 19.181-33.2 18.665v-8e-3l-0.026-0.015-0.024 37.153-32.172 18.547 32.749 18.871 64.867-37.466v-75.053zm-97.4 18.821v74.964l0.095 0.055 32.587-18.321 1e-3 -0.023-32.616-18.859 32.21-18.569-6e-3 -3e-3 0.024-37.848z"/>
          <path d="m64.583 56.748v8e-3l33.2-18.665-33.172-19.181-0.024 37.84z" opacity=".5"/>
          <path
              d="m48.842 47.594v2e-3l15.713 9.085v1e-3l2e-3 -2e-3v0.053l0.026 0.015 0.025-37.84 3e-3 2e-3v-7e-3l-32.316-18.686-0.024 37.848 6e-3 3e-3 0.046-0.026z"
              opacity=".35"/>
          <path d="m64.557 56.733-3e-3 -2e-3 -31.851 18.777-0.427 36.876 0.085 0.049 32.172-18.547z" opacity=".7"/>
          <path d="m64.512 56.707-32.235-18.639-32.21 18.569 32.616 18.859v-0.026z" opacity=".6"/>
          <path d="m32.682 75.519-32.587 18.321l32.161 18.532 1e-3 -0.057 0.104 0.118z" opacity=".8"/>
        </g>
      </svg>
    </div>

    <Modal title="Forecasts" ref="modelForecast" showRefreshButton>

      <div class="item tile" v-for="(item, index) in actives">
        <header>{{ item.title }}</header>

        <div class="text">
          <div :class="item.processStatusName.toLowerCase()" class="state"></div>
          <p>
            {{ item.processStatusName }}
            <small :title="item.updateDate | moment('DD/MM/YYYY')">Modified:
              {{ $moment.utc(item.updateDate).local().from() }}</small>
          </p>
          <button class="outline" v-on:click="item.isOpen = !item.isOpen">Logs</button>
          <button class="outline" v-if="item.processStatus === 2" v-on:click="onViewDataClick(item)">View data</button>
          <button class="outline" v-if="item.processStatus === 4" v-on:click="onDownloadLogClick(item)">Download log
          </button>
          <button class="outline" v-if="item.processStatus === 3" v-on:click="onStopClick(item, $event)">Stop</button>
        </div>
        <pre class="logview" v-show="item.isOpen"><template v-for="log in item.logs">{{
            log.logDate | moment('HH:mm:ss')
          }}: {{ log.text }}<br></template></pre>
      </div>

    </Modal>
  </div>
</template>

<script>
import Modal from "./Modal.vue"
import * as signalR from '@aspnet/signalr'

export default {
  components: {
    Modal
  },
  name: "ForecastRunnerStatus",
  data: () => ({
    actives: [],
    showDongle: false,
    connection: null
  }),
  mounted() {
    this.connection = new signalR
        .HubConnectionBuilder()
        .withUrl("/hub/forecastrunner")
        .build();

    this.connection.on("ReceiveLog", data => {
      //debugger;
      this.writeLogLine(data)
    });

    this.connection.on("ReceiveActives", data => {
      this.actives = data;
      //this.testLoadSupplyPlan();
      if (data.length > 0)
        this.showDongle = true;
    });

    this.connection.on("ReceiveEndForecast", data => {
      this.connection.invoke("GetActives");

      // Update version data
      
      let version = this.$store.getters.forecastVersion(data.forecastVersionId);
      version.processStatus = data.processStatus;
      version.processStatusName = data.processStatusName;
      version.updateDate = data.updateDate;
      version.forecastId = data.forecastId;

      var retrieveSupplyPlan = (version.processStatus === 2 || version.processStatus === 3) && !this.isAggregation()
      if (retrieveSupplyPlan) {
        {

          this.importSupplyPlansByJson(version.data, data.forecastVersionId);
        }
      }
                
    });

    this.connection.onclose(() => {
      console.log("ForecastRunner WS closed");
      setTimeout(() => {
        console.log("Attempt restart");
        this.connection.start();
      }, 15000);
    });

    this.connection
        .start()
        .then(() => {
          this.connection.invoke("GetActives").catch(function (error) {
            console.error(error.toString());
          });
        })
        .catch(function (error) {
          return console.error(error.toString());
        });

    // Open when a Run is triggered
    this.$store.subscribe((mutation) => {
      if (mutation.type === "runStudy") {
        this.connection.invoke("GetActives");

        this.$refs.modelForecast.show();
      }
    })

  },
  methods: {
    writeLogLine(data) {
      let version = this.actives.find(x => x.forecastId === data.forecastId);
      if (!this.NullOrUndefined(version) && !this.NullOrUndefined(version.logs))
      {
        //debugger;
        version.logs.push(data)
      }
    },
    isAggregation() {
      return this.$router.currentRoute.name.indexOf("Aggregator") > -1
    },
    toggleLogView() {
      this.$refs.modelForecast.show();
    },
    onViewDataClick(item) {
      this.$refs.modelForecast.hide();
      this.$router.push(item.url)
    },
    onDownloadLogClick(item) {
      window.open("/api/download/log?id=" + item.forecastId)
    },
    onStopClick(item, event) {
      let btn = event.currentTarget;

      btn.disabled = true;
      btn.textContent = "Stopping...";

      this.connection.invoke("Stop", item.forecastId);
    }
  }
}
</script>